import { FC } from 'react';
import ContentLayout from '@/layouts/ContentLayout';
import classNames from 'classnames';
import NumberListingItem from './NumberListingItem';

interface NumberListingProps {
    listingItems: {
        title: string;
        count: string;
        id: string;
    }[];
    className?: string;
}

const NumberListing: FC<NumberListingProps> = ({ listingItems, className }) => {
    // tw-grid-cols-${listingItems.length} can't be used due to https://tailwindcss.com/docs/content-configuration#dynamic-class-names
    let gridColsLenght = '';
    switch (listingItems.length) {
        case 2:
            gridColsLenght = 'tw-grid-cols-2';
            break;
        case 3:
            gridColsLenght = 'tw-grid-cols-3';
            break;
        case 4:
            gridColsLenght = 'tw-grid-cols-4';
            break;
        default:
            gridColsLenght = 'tw-grid-cols-3';
    }

    return (
        <ContentLayout>
            <div
                className={classNames(
                    `tw-w-full tw-grid tw-gap-5 tw-pt-[33px]`,
                    gridColsLenght,
                    className,
                )}
            >
                {listingItems.map((item) => (
                    <NumberListingItem
                        key={item.id}
                        id={item.id}
                        title={item.title}
                        count={item.count}
                        length={listingItems.length}
                    />
                ))}
            </div>
        </ContentLayout>
    );
};

export default NumberListing;
